import axios from "axios";

const api = axios.create({
  baseURL: "http://localhost:8080",
});

const token = localStorage.getItem("token");
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const tapi = axios.create({
  baseURL: "http://localhost:8080",
  headers: headers,
});

const loginUser = (post) => api.post("/login", post);
const sendCode = (post) => api.post("/sendpasscode", post);
const verifyCode = (post) => api.post("/verifypasscode", post);
const updatePwd = (post) => api.post("/setpassword", post);
const currentUser = () => tapi.get("/currentuser");
const updateUser = (id, data) => tapi.put(`/user/${id}`, data);
const updatePassword = (post) => tapi.post("/updatepassword", post);

export {
  loginUser,
  sendCode,
  verifyCode,
  updatePwd,
  currentUser,
  updateUser,
  updatePassword,
};
